import { render } from "./shareTrainingCampTask.vue?vue&type=template&id=5b5145fe&scoped=true"
import script from "./shareTrainingCampTask.vue?vue&type=script&lang=js"
export * from "./shareTrainingCampTask.vue?vue&type=script&lang=js"

import "./shareTrainingCampTask.vue?vue&type=style&index=0&id=5b5145fe&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5145fe"]])

export default __exports__